import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ConfigProvider, Spin } from "antd";
import { AuthProvider } from "./context/AuthContext";
import { AppContextProvider, useAppContext } from "./context/AppContext";
import PrivateRoute from "./components/PrivateRoute";

import Login from "./pages/Login/Login";
import ForgotPassword from "./pages/Login/ForgotPassword";
import ResetPassword from "./pages/Login/ResetPassword";
import Dashboard from "./pages/Dashboard/Dashboard";
import Employees from "./pages/Employees/Employees";
import Policies from "./pages/Policies/Policies";
import PolicyForm from "./pages/Policies/PolicyForm";
import EmployeeProfile from "./pages/Employees/EmployeeProfile";
import EmployeeForm from "./pages/Employees/EmployeeForm";
import Departments from "./pages/Departments/Departments";
import Roles from "./pages/Roles/Roles";
import Offices from "./pages/Offices/Offices";
import WorkingHours from "./pages/WorkingHours/WorkingHours";
import Attendance from "./pages/Attendance/Attendance";
import ActivityHistory from "./pages/ActivityHistory/ActivityHistory";
import Holidays from "./pages/Holidays/Holidays";
import Leave from "./pages/Leave/Leave";
import WFHRequests from "./pages/WFHRequests/WFHRequests";
import PayRun from "./pages/PayRun/PayRun";
import Reimbursements from "./pages/Reimbursements/Reimbursements";
import OvertimeRequests from "./pages/OvertimeRequests/OvertimeRequests";
import Benefits from "./pages/Benefits/Benefits";
import Reports from "./pages/Reports/Reports";
import AuditLog from "./pages/AuditLog/AuditLog";

const GlobalLoader = () => {
  const { loading } = useAppContext();
  if (!loading) return null;
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(255,255,255,0.5)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Spin size="large" />
    </div>
  );
};

function App() {
  return (
    <ConfigProvider theme={{ token: { colorPrimary: "#0B2545" } }}>
      <AppContextProvider>
        <AuthProvider>
          <GlobalLoader />
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/" element={<Navigate to="/dashboard" />} />
              <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
              <Route path="/employees" element={<PrivateRoute><Employees /></PrivateRoute>} />
              <Route path="/employees/new" element={<PrivateRoute><EmployeeForm /></PrivateRoute>} />
              <Route path="/employees/:id" element={<PrivateRoute><EmployeeProfile /></PrivateRoute>} />
              <Route path="/employees/:id/edit" element={<PrivateRoute><EmployeeForm /></PrivateRoute>} />
              <Route path="/departments" element={<PrivateRoute><Departments /></PrivateRoute>} />
              <Route path="/roles" element={<PrivateRoute><Roles /></PrivateRoute>} />
              <Route path="/offices" element={<PrivateRoute><Offices /></PrivateRoute>} />
              <Route path="/working-hours" element={<PrivateRoute><WorkingHours /></PrivateRoute>} />
              <Route path="/attendance" element={<PrivateRoute><Attendance /></PrivateRoute>} />
              <Route path="/activity-history" element={<PrivateRoute><ActivityHistory /></PrivateRoute>} />
              <Route path="/employee-calendar" element={<Navigate to="/attendance?tab=calendar" replace />} />
              <Route path="/policies" element={<PrivateRoute><Policies /></PrivateRoute>} />
              <Route path="/policies/new" element={<PrivateRoute><PolicyForm /></PrivateRoute>} />
              <Route path="/policies/:id" element={<PrivateRoute><PolicyForm /></PrivateRoute>} />
              <Route path="/holidays" element={<PrivateRoute><Holidays /></PrivateRoute>} />
              <Route path="/leave" element={<PrivateRoute><Leave /></PrivateRoute>} />
              <Route path="/leave-settings" element={<Navigate to="/leave?tab=types" replace />} />
              <Route path="/leave-requests" element={<Navigate to="/leave?tab=requests" replace />} />
              <Route path="/wfh-requests" element={<PrivateRoute><WFHRequests /></PrivateRoute>} />
              <Route path="/pay-run" element={<PrivateRoute><PayRun /></PrivateRoute>} />
              <Route path="/reimbursements" element={<PrivateRoute><Reimbursements /></PrivateRoute>} />
              <Route path="/overtime-requests" element={<PrivateRoute><OvertimeRequests /></PrivateRoute>} />
              <Route path="/benefits" element={<PrivateRoute><Benefits /></PrivateRoute>} />
              <Route path="/reports" element={<PrivateRoute><Reports /></PrivateRoute>} />
              <Route path="/audit-log" element={<PrivateRoute><AuditLog /></PrivateRoute>} />
              <Route path="*" element={<Navigate to="/dashboard" />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </AppContextProvider>
    </ConfigProvider>
  );
}

export default App;
